/**
 * The account email, when it is already a real address.
 * Empty, whitespace, and non-addresses stay empty — never invent one.
 */
export function knownAccountEmail(value: string | null | undefined): string | null {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) return null;
  return trimmed;
}

/** Stamp a form payload with the account email when we already have one. */
export function withAccountPrimaryEmail<T extends object>(
  data: T,
  accountEmail: string | null | undefined,
): T {
  const known = knownAccountEmail(accountEmail);
  if (!known) return data;
  return { ...data, primaryEmail: known };
}
